const styleSheet = () => ({
  header: {
    paddingLeft: '16px',
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: '10px',
    '& h2': {
      color: '#051D39',
      fontFamily: "'Museo Sans', sans-serif",
      fontWeight: 700,
      fontSize: '24px',
      marginRight: '15px',
    },
  },
  noResultContainer: {
    display: 'block',
    margin: '0 auto',
    marginTop: '50px',
    height: '301px',
    width: '484px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.15)',
  },
  noListsText: {
    height: '22px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '16px',
    letterSpacing: '0',
    lineHeight: '22px',
    marginBottom: '20px',
  },
});

export default styleSheet;
